import { ACCORDION_LAYOUT, AUTO, NEVER, TABS_LAYOUT } from '../constants/PaymentElement';
import { ACH, AFFIRM, BACS, CARD, KLARNA, PADS, SEPA } from '../constants/PaymentMethods';
export const getBillingNameSetting = paymentMethod => {
  switch (paymentMethod) {
    case CARD:
      return NEVER;
    case ACH:
      return NEVER;
    case BACS:
      return AUTO;
    case PADS:
      return NEVER;
    case SEPA:
      return AUTO;
    // BNPL methods collect billing details in their own redirect flow;
    // AUTO lets the Payment Element show fields Stripe requires up front
    case KLARNA:
    case AFFIRM:
      return AUTO;
    default:
      return NEVER;
  }
};
export const getBillingFieldSetting = (collectFullBillingAddress, collectShippingAddress, paymentMethod, hasCalculateAtCheckoutTaxes) => {
  switch (paymentMethod) {
    case CARD:
      if (collectFullBillingAddress || collectShippingAddress) {
        return NEVER;
      }
      return AUTO;
    case ACH:
      if (collectShippingAddress) {
        return NEVER;
      }
      // collectFullBillingAddress only affects CARD except when hasCalculateAtCheckoutTaxes is true
      if (collectFullBillingAddress && hasCalculateAtCheckoutTaxes) {
        return NEVER;
      }
      return AUTO;
    // BNPL requires at minimum email + country; always let the Payment Element collect them
    case KLARNA:
    case AFFIRM:
      return AUTO;
    default:
      return AUTO;
  }
};
export const getPaymentElementLayout = paymentMethods => {
  const hasCard = paymentMethods.some(({
    paymentMethod
  }) => paymentMethod === CARD);

  // Effective count adds 2 for Apple/Google Pay wallets when card is present,
  // since Stripe surfaces them at runtime alongside configured methods.
  // We switch to accordion only above 4 to keep CARD+ACH in the simpler tabs layout.
  if (paymentMethods.length + (hasCard ? 2 : 0) > 4) {
    return {
      type: ACCORDION_LAYOUT,
      radios: true,
      spacedAccordionItems: true,
      defaultCollapsed: false
    };
  }
  return {
    type: TABS_LAYOUT,
    defaultCollapsed: false
  };
};